import * as React from 'react';

import { MortgageOffersNotFound } from '../../../components/NewbuildingMortgageSection';
import { useApplicationContext } from '../../ApplicationContext';
import { getCianMortgageBannerUrl } from '../helpers';

export const MortgageOffersNotFoundContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const mortgageUrl = getCianMortgageBannerUrl(config);

  return <MortgageOffersNotFound mortgageUrl={mortgageUrl} />;
};
